<section
  class="breeder-week-registration-detailed spacing--margin-half-top"
  data-test="breeder-week-registration-detailed"
>
  <mat-select
    class="breeder-week-registration-detailed__sort-by"
    [hideSingleSelectionIndicator]="true"
    [value]="sortDirection()"
    (valueChange)="setSortDirection($event)"
    data-test="breeder-week-registration-detailed__sort-by"
  >
    <mat-option value="asc">
      {{ 'flock-overview.week-registrations.sortByAscending' | translate }}
    </mat-option>
    <mat-option value="desc">
      {{ 'flock-overview.week-registrations.sortByDescending' | translate }}
    </mat-option>
  </mat-select>

  <div class="breeder-week-registration-detailed__table-container">
    <table>
      <thead>
        <tr>
          <th scope="col">{{ 'week-registration.week' | translate }}</th>
          <th scope="col">{{ 'week-registration.week-start' | translate }}</th>
          @for (column of columns(); track column.parameter) {
          <th scope="col">
            @if (column.chartable) {
            <button
              type="button"
              class="breeder-week-registration-detailed__kpi-header"
              [attr.data-test]="'breeder-week-registration-detailed__chart-' + column.parameter"
              (click)="openChart(column)"
            >
              {{ 'flock-overview.week-registrations.breeder-kpis.' + column.parameter | translate }}
              @if (column.unit) {
              <span>({{ column.unit }})</span>
              }
            </button>
            } @else { {{ 'flock-overview.week-registrations.breeder-kpis.' + column.parameter |
            translate }} @if (column.unit) {
            <span>({{ column.unit }})</span>
            } }
          </th>
          }
          <th aria-hidden="true" class="breeder-week-registration-detailed__spacer-column"></th>
        </tr>
      </thead>
      <tbody>
        @for (row of rows(); track row.week) {
        <tr [attr.data-test]="'breeder-week-registration-detailed__week-' + row.week">
          <td>{{ row.week }}</td>
          <td>{{ row.weekStartDate | date: 'shortDate' }}</td>
          @for (column of columns(); track column.parameter) {
          <td [attr.data-test]="'breeder-week-registration-detailed__' + column.parameter">
            {{ formatValue(row, column) }}
          </td>
          }
          <td aria-hidden="true" class="breeder-week-registration-detailed__spacer-column"></td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</section>
